import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  addNotesToTimecardRecord,
  getNotesToTimecardRecord,
} from "../../../redux/features/EmployeeTimeCard"; // Adjust path as needed
import { useAppDispatch } from "../../../redux/store";
import { useSelector } from "react-redux";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout";
interface ChildProps {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddNoteTimecard: React.FC<ChildProps> = ({ loading, setLoading }) => {
  const [note, setNote] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const user = useSelector((state: any) => state?.user?.user);
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string }>();
  const handleSubmit = async () => {
    if (note.trim() === "") {
      alert("Please enter a note!");
      return;
    }
    setLoading(true);
    setIsSubmitting(true);
    const payload = {
      record_id: params.id!,
      employee_id: user.id,
      notes: note,
    };
    try {
      await dispatch(addNotesToTimecardRecord(payload))
      .then(() => {
          setLoading(true);
          setNote("");
          const recordPayload = { id: Number(params?.id), employee_id: user?.id };
          dispatch(getNotesToTimecardRecord(recordPayload)).then(() => {setLoading(false)})
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setNote("");
      alert("Failed to add note.");
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    dispatch(setTopNavNameTitle("Add a Note"));
  }, []);

  return (
    <>
      <div className="mb-4">
        <textarea
          className="w-full p-4 border-2 rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
          rows={6}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter your note here..."
        />
      </div>
      <button
        onClick={handleSubmit}
        disabled={isSubmitting}
        className="px-6 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-gray-400 transition-all"
      >
        {isSubmitting ? "Saving..." : "Add Note"}
      </button>
    </>
  );
};

export default AddNoteTimecard;
